"use client"
import { createSvgIcon, useTheme } from "@mui/material"
import type { IconProps } from "../types"
import { getPath } from "../utils"

const CheckBoxOutlined = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 3350">
      <rect
        id="Rectangle 1354"
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="3.5"
        fill="white"
        stroke="#3F4855"
      />
      <g id="check">
        <mask
          id="mask0_25_10934"
          // style="mask-type:alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <rect id="Bounding box" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_25_10934)">
          <path
            d="M9.875 14.3249L16.475 7.74986C16.6583 7.56653 16.8667 7.47903 17.1 7.48736C17.3333 7.49569 17.5417 7.59153 17.725 7.77486C17.9083 7.95819 18 8.16653 18 8.39986C18 8.63319 17.9083 8.84153 17.725 9.02486L10.525 16.2249C10.3417 16.4082 10.1292 16.4999 9.8875 16.4999C9.64583 16.4999 9.43333 16.4082 9.25 16.2249L6.275 13.2499C6.09167 13.0665 6 12.8582 6 12.6249C6 12.3915 6.09167 12.1832 6.275 11.9999C6.45833 11.8165 6.66667 11.7249 6.9 11.7249C7.13333 11.7249 7.34167 11.8165 7.525 11.9999L9.875 14.3249Z"
            fill="#1E2C3F"
          />
        </g>
      </g>
    </g>
  </svg>,
  "CheckBoxOutlined",
)

const CheckBoxOutlinedIcon = (props: IconProps) => {
  const { fill, sx, ...rest } = props
  const theme = useTheme()
  const _fill =
    (fill && getPath(theme.palette, fill)) || theme.palette.text.primary
  return <CheckBoxOutlined sx={{ fill: _fill, ...sx }} {...rest} />
}

export default CheckBoxOutlinedIcon
